module.exports = __webpack_public_path__ + "img/hr-concrete.dabc5fbb.png";